<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="pt-3 pb-3 pr-3 prof-main-container">
			<div class="d-flex align-items-center">
				<div class="heading-container boxtext ml-3">
					<span>Profile</span>
				</div>
			</div>
			<div class="d-flex mt-3 profile-main-container">
				<div
					style="width: 25%"
					class="profile-left-container d-flex flex-column px-3 pt-3 h-100 mr-3"
				>
					<div
						:class="
							showProfInfo === true
								? 'left-selected-container'
								: 'left-unselected-container'
						"
						class="d-flex align-items-center pointer mb-3"
						@click="showProfile"
					>
						<div class="blue-line"></div>
						<div class="ml-4">Profile Info</div>
					</div>
					<div
						:class="
							showBasicAut === true
								? 'left-selected-container'
								: 'left-unselected-container'
						"
						class="d-flex align-items-center pointer mb-3"
						@click="showBasicAuth()"
					>
						<div class="blue-line"></div>

						<div class="ml-4">Basic Authentication</div>
					</div>
					<div
						:class="
							showDevAct === true
								? 'left-selected-container'
								: 'left-unselected-container'
						"
						class="d-flex align-items-center pointer mb-3"
						@click="showDevice()"
					>
						<div class="blue-line"></div>

						<div class="ml-4">Device Activity</div>
					</div>
					<div
						v-if="count > 1"
						:class="
							showPreference === true
								? 'left-selected-container'
								: 'left-unselected-container'
						"
						class="d-flex align-items-center pointer mb-3"
						@click="preferenceShow()"
					>
						<div class="blue-line"></div>

						<div class="ml-4">Preference Settings</div>
					</div>
				</div>
				<div
					style="width: 75%"
					class="profile-right-container overflow-auto h-100"
				>
					<div
						class="right-selected-container pointer"
						v-if="showProfInfo"
						@click="
							(showProfInfo = !showProfInfo),
								(showDevAct = false),
								(showApp = false),
								(showBasicAut = false),
								(showPreference = false)
						"
					>
						<div
							class="right-heading-container d-flex align-items-center justify-content-between"
						>
							<div class="right-selected-heading">Profile Info</div>
							<img
								class="pointer"
								src="../assets/mainProfile/up_arrow.svg"
								alt=""
							/>
						</div>
						<hr class="profile-hr" />
						<div class="profile-form-class" @click.stop="">
							<b-row>
								<b-col>
									<div class="topDiv">
										<label class="fieldsetStyle"
											>First Name &nbsp;<span class="asterik">*</span></label
										>
										<b-form-input
											:class="{ error: $v.firstName.$error }"
											class="profile-input"
											placeholder="Enter First Name"
											type="text"
											v-model="$v.firstName.$model"
										>
										</b-form-input>
										<div
											class="validationicon"
											v-if="$v.firstName.$dirty && !$v.firstName.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											class="validationicon"
											v-if="!$v.firstName.maxLength && $v.firstName.required"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 128 characters',
											}"
											variant="primary"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col>
									<div class="topDiv">
										<label class="fieldsetStyle"
											>Last Name &nbsp;<span class="asterik">*</span></label
										>
										<b-form-input
											:class="{ error: $v.lastName.$error }"
											class="profile-input"
											placeholder="Enter Last Name"
											type="text"
											v-model="$v.lastName.$model"
										>
										</b-form-input>
										<div
											class="validationicon"
											v-if="$v.lastName.$dirty && !$v.lastName.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											class="validationicon"
											v-if="!$v.lastName.maxLength && $v.lastName.required"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 128 characters',
											}"
											variant="primary"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<div class="topDiv mt-4">
										<label class="disable-fieldsetStyle"
											>Email &nbsp;<span class="asterik">*</span></label
										>
										<b-form-input
											:class="{ error: $v.profileEmail.$error }"
											class="disable-inputField"
											placeholder="Enter Email"
											type="email"
											v-model="$v.profileEmail.$model"
											disabled
										>
										</b-form-input>
										<div
											class="validationicon"
											v-if="$v.profileEmail.$dirty && !$v.profileEmail.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											class="validationicon"
											v-if="
												!$v.profileEmail.alpha ||
												($v.profileEmail.required && !$v.profileEmail.email)
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter proper email address',
											}"
											variant="primary"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col></b-col>
							</b-row>
							<div class="d-flex align-items-center justify-content-end mt-5">
								<b-button class="addbtn px-4" @click="getProfile()"
									>Save</b-button
								>
							</div>
						</div>
					</div>
					<div
						v-else
						class="right-unselected-container d-flex align-items-center justify-content-between pointer"
						@click="
							(showProfInfo = !showProfInfo),
								(showDevAct = false),
								(showApp = false),
								(showBasicAut = false),
								(showPreference = false)
						"
					>
						<div>Profile Info</div>
						<img
							class="pointer"
							src="../assets/mainProfile/down_arrow.svg"
							alt=""
						/>
					</div>
					<div
						class="right-selected-container mt-3 pointer"
						v-if="showBasicAut"
						@click="
							(showBasicAut = !showBasicAut),
								(showProfInfo = false),
								(showDevAct = false),
								(showApp = false),
								(resetPassword = false),
								(showPreference = false)
						"
					>
						<div
							class="right-heading-container d-flex align-items-center justify-content-between"
						>
							<div class="right-selected-heading">Basic Authentication</div>
							<img
								class="pointer"
								src="../assets/mainProfile/up_arrow.svg"
								alt=""
							/>
						</div>
						<hr class="profile-hr" />
						<div
							class="profile-form-class"
							@click.stop=""
							v-if="!resetPassword"
						>
							<b-row>
								<b-col cols="4"
									><div class="profile-password">Passsword</div></b-col
								>
							</b-row>
							<b-row class="mt-3 d-flex align-items-center">
								<b-col cols="8"
									><div class="profile-password">***********</div></b-col
								>
								<b-col>
									<div class="d-flex justify-content-end align-items-center">
										<div
											class="profile-reset-btn text-center pointer py-2"
											@click="resetPassword = true"
										>
											Reset Password
										</div>
									</div>
								</b-col>
							</b-row>
						</div>
						<div class="profile-form-class" @click.stop="" v-else>
							<b-row>
								<b-col cols="6">
									<div class="topDiv">
										<label class="fieldsetStyle"
											>Current Password&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											:class="{ error: $v.currentPassword.$error }"
											class="profile-input"
											placeholder="Enter Current Password"
											type="password"
											autocomplete="new-password"
											v-on:keyup.enter="resetPwd()"
											v-model="currentPassword"
										>
										</b-form-input>
										<div
											class="profile-password-text"
											v-if="checkCurrentPsw == true"
										>
											Current password is incorrect
										</div>
										<div
											class="validationicon"
											v-if="
												$v.currentPassword.$dirty &&
												!$v.currentPassword.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<div class="topDiv mt-4">
										<label class="fieldsetStyle"
											>New Password&nbsp;<span class="asterik">*</span></label
										>
										<b-form-input
											:class="{ error: $v.newPswd.$error }"
											class="profile-input"
											placeholder="Enter New Password"
											v-on:keyup.enter="resetPwd()"
											type="password"
											v-model="newPswd"
										>
										</b-form-input>
										<div
											class="profile-password-text"
											v-if="checkNewPsw == true && newPswd != ''"
										>
											The new password shouldn't match the current password
										</div>
										<div
											class="validationicon"
											v-if="$v.newPswd.$dirty && !$v.newPswd.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col>
									<div class="topDiv mt-4">
										<label class="fieldsetStyle"
											>Confirm Password&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											:class="{ error: $v.confirmPswd.$error }"
											class="profile-input"
											placeholder="Confirm New Password"
											type="password"
											v-model="confirmPswd"
											v-on:keyup.enter="resetPwd()"
										>
										</b-form-input>
										<div
											class="profile-password-text"
											v-if="checkConfirmPsw == true && confirmPswd != ''"
										>
											The confirm password should match the new password
										</div>
										<div
											class="validationicon"
											v-if="$v.confirmPswd.$dirty && !$v.confirmPswd.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										>
											<img src="../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<div class="d-flex align-items-center justify-content-end mt-5">
								<div
									class="cancelbtntext pointer mr-4"
									@click="cancelResetPswd()"
								>
									Cancel
								</div>
								<b-button class="addbtn px-4" @click="resetPwd()"
									>Update</b-button
								>
							</div>
						</div>
					</div>
					<div
						v-else
						class="right-unselected-container mt-3 d-flex align-items-center justify-content-between pointer"
						@click="
							(showBasicAut = !showBasicAut),
								(showProfInfo = false),
								(showDevAct = false),
								(showApp = false),
								(showPreference = false)
						"
					>
						<div>Basic Authentication</div>
						<img
							class="pointer"
							src="../assets/mainProfile/down_arrow.svg"
							alt=""
						/>
					</div>
					<div
						class="right-selected-container mt-3 pointer"
						v-if="showDevAct"
						@click="
							(showDevAct = !showDevAct),
								(showBasicAut = false),
								(showProfInfo = false),
								(showApp = false)
						"
					>
						<div
							class="right-heading-container d-flex align-items-center justify-content-between"
						>
							<div class="right-selected-heading">Device Activity</div>
							<img
								class="pointer"
								src="../assets/mainProfile/up_arrow.svg"
								alt=""
							/>
						</div>
						<hr class="profile-hr" />
						<div class="profile-card-class" @click.stop="">
							<div
								v-for="(i, index) in deviceCheck"
								:key="index"
								class="profile-card mt-3 d-flex align-items-center"
							>
								<div
									style="width: 5%"
									class="d-flex justify-content-center mr-3"
								>
									<img
										src="../assets/mainProfile/google_chrome.svg"
										alt="Google Chrome Icon"
									/>
								</div>
								<div style="width: 85%">
									<b-row>
										<b-col>
											<div class="d-flex align-items-center">
												<div
													style="color: #000000"
													class="profile-before-colon-text"
												>
													{{ i.browser }}
												</div>
												<div
													class="profile-currently-active"
													v-if="i.current == true"
												>
													Currently Active
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row class="mt-3"
										><b-col cols="4"
											><div class="d-flex align-items-center">
												<div class="profile-before-colon-text">
													Last accessed :
												</div>
												<div class="profile-after-colon-text">
													&nbsp;{{ i.formattedLastAccess }}
												</div>
											</div></b-col
										><b-col cols="4">
											<div class="d-flex align-items-center">
												<div class="profile-before-colon-text">
													Started at &nbsp;:
												</div>
												<div class="profile-after-colon-text">
													&nbsp;{{ i.formattedStartedDate }}
												</div>
											</div></b-col
										><b-col cols="4">
											<div class="d-flex align-items-center">
												<div class="profile-before-colon-text">
													Expires at &nbsp;:
												</div>
												<div class="profile-after-colon-text">
													&nbsp; {{ i.formattedExpire }}
												</div>
											</div></b-col
										></b-row
									>
								</div>
								<!-- Style bind opacity if Sign Out is disabled -->
								<div
									v-if="i.current == true"
									style="width: 10%"
									class="profile-sign-out"
									@click="signOut(i)"
								>
									Sign Out
								</div>
							</div>
						</div>
					</div>
					<div
						v-else
						class="right-unselected-container mt-3 d-flex align-items-center justify-content-between pointer"
						@click="
							(showDevAct = !showDevAct),
								(showBasicAut = false),
								(showProfInfo = false),
								(showApp = false),
								(showPreference = false)
						"
					>
						<div>Device Activity</div>
						<img
							class="pointer"
							src="../assets/mainProfile/down_arrow.svg"
							alt=""
						/>
					</div>
					<div
						class="right-selected-container mt-3"
						v-if="showPreference && count > 1"
					>
						<div>
							<div
								@click="
									(showPreference = !showPreference),
										(showBasicAut = false),
										(showProfInfo = false),
										(showDevAct = false),
										(showApp = false)
								"
								class="pointer right-heading-container d-flex align-items-center justify-content-between"
							>
								<div class="right-selected-heading pl-0">
									Preference Settings
								</div>
								<img
									class="pointer"
									src="../assets/mainProfile/up_arrow.svg"
									alt=""
								/>
							</div>
							<hr class="profile-hr" />
							<div class="profile-form-class">
								<span class="candash-head">
									Logging in can be changed according to your preferences.
								</span>
								<div class="pref-setting mt-4">
									<div class="js-head-txt">Apps</div>
									<div class="d-flex mt-3 mb-4">
										<div
											class="d-flex flex-column align-items-center pref-cards"
										>
											<div>
												<img src="../assets/mainProfile/profAsses.svg" alt="" />
											</div>
											<div class="mt-2">
												<b-form-radio
													v-model="selected"
													value="assessment"
													size="sm"
													>Assessment</b-form-radio
												>
											</div>
										</div>
										<div
											v-if="accessRecruitment"
											class="d-flex flex-column align-items-center pref-cards"
										>
											<div>
												<img src="../assets/mainProfile/profRec.svg" alt="" />
											</div>
											<div class="mt-2">
												<b-form-radio
													v-model="selected"
													value="recruitment"
													size="sm"
													>Recruitment</b-form-radio
												>
											</div>
										</div>
										<div
											v-if="accessTraining"
											class="d-flex flex-column align-items-center pref-cards"
										>
											<div>
												<img src="../assets/mainProfile/profTran.svg" alt="" />
											</div>
											<div class="mt-2">
												<b-form-radio
													v-model="selected"
													value="training"
													size="sm"
													>Training</b-form-radio
												>
											</div>
										</div>
										<div
											v-if="accessCandidate"
											class="d-flex flex-column align-items-center pref-cards"
										>
											<div>
												<img src="../assets/mainProfile/profCand.svg" alt="" />
											</div>
											<div class="mt-2">
												<b-form-radio
													v-model="selected"
													value="candidate"
													size="sm"
													>Candidate</b-form-radio
												>
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-end mt-5"
									>
										<!-- <div class="cancelbtntxt pointer mr-4">Cancel</div> -->
										<b-button class="addbtn px-4" @click="setPref()"
											>Save</b-button
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-else-if="count > 1"
						class="right-unselected-container mt-3 d-flex align-items-center justify-content-between pointer"
						@click="
							getPref(),
								(showPreference = !showPreference),
								(showDevAct = false),
								(showBasicAut = false),
								(showProfInfo = false),
								(showApp = false)
						"
					>
						<div>Preference Settings</div>
						<img
							class="pointer"
							src="../assets/mainProfile/down_arrow.svg"
							alt=""
						/>
					</div>
					<!-- preferences  -->

					<!-- <div
            class="right-selected-container mt-3 pointer"
            v-if="showApp"
            @click="
              (showApp = !showApp),
                (showDevAct = false),
                (showBasicAut = false),
                (showProfInfo = false)
            "
          >
            <div
              class="right-heading-container d-flex align-items-center justify-content-between"
            >
              <div class="right-selected-heading">Applications</div>
              <img
                class="pointer"
                src="../assets/mainProfile/up_arrow.svg"
                alt=""
              />
            </div>
            <hr class="profile-hr" />
            <div class="profile-card-class">
              <div
                v-for="(i, index) in getApplication"
                :key="index"
                class="profile-card d-flex align-items-center mt-3"
              >
                <div class="d-flex align-items-center">
                  <img
                    src="../assets/mainProfile/google_chrome.svg"
                    alt="Google Chrome Icon"
                  />
                  <div
                    style="color: #000000"
                    class="profile-before-colon-text ml-2"
                  >
                    {{ i.clientId }}
                  </div>
                </div>
                <div class="d-flex ml-5">
                  <div class="profile-before-colon-text">
                    Application Type&nbsp;:
                  </div>
                  <div class="profile-after-colon-text">&nbsp;Internal</div>
                </div>
                <div class="d-flex ml-5" v-if="i.inUse == true">
                  <div class="profile-before-colon-text">Status &nbsp;:</div>
                  <div class="profile-after-colon-text">&nbsp;In Use</div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="right-unselected-container mt-3 d-flex align-items-center justify-content-between pointer"
            @click="
              (showApp = !showApp),
                (showDevAct = false),
                (showBasicAut = false),
                (showProfInfo = false)
            "
          >
            <div>Applications</div>
            <img
              class="pointer"
              src="../assets/mainProfile/down_arrow.svg"
              alt=""
            />
          </div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
const qs = require("qs");
import successToast from "../views/mixin/toast.js";
import errorToast from "../views/mixin/toast";
import Spinner from "../components/fixedcomponents/Spinner.vue";
import { required, email, maxLength, helpers } from "vuelidate/lib/validators";
import { postPreference, getPreference } from "../utils/apiFunctions";

import {
	getDeviceActivity,
	getProfileInfo,
	signOutDevices,
	signOutAllDevices,
	getProfileDetails,
	userLogin,
	resetPassword,
} from "../utils/apiFunctions";
export default {
	name: "Profile",
	mixins: [successToast, errorToast],

	components: {
		Spinner,
	},

	data() {
		return {
			// Variables to show or hide different containers/sections
			showProfInfo: false, // Show Profile Info
			showBasicAut: false, // Show Basic Authentication
			resetPassword: false, // Flag for resetting password
			showPreference: false, //show preferences
			showDevAct: false, // Show Device Activity
			showApp: false, // Show Application
			LoaderStatus: false, // Flag to indicate loading state
			checkCurrentPsw: false,
			checkNewPsw: false,
			accessRecruitment: false,
			accessTraining: false,
			accessCandidate: false,
			accessAssessment: true,
			checkConfirmPsw: false,
			selected: null,
			status: null,

			// Form fields for password reset
			currentPassword: "",
			newPswd: "",
			confirmPswd: "",

			// Profile related fields
			profileEmail: "",
			firstName: "",
			lastName: "",
			givenPsw: "",
			count: 1,

			// Arrays to store device activity and application data
			deviceCheck: [],
			getApplication: [],
		};
	},

	computed: {
		// Mapping Vuex getters to computed properties
		...mapGetters("userVUEX", {
			User: "getRoleValues", // Get user role values
		}),
	},

	validations: {
		// Validation rules for form fields
		firstName: {
			required,
			maxLength: maxLength(128),
			alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
		},
		lastName: {
			required,
			maxLength: maxLength(128),
			alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
		},
		profileEmail: {
			required,
			email,
			alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
		},
		confirmPswd: {
			required,
		},
		newPswd: {
			required,
		},
		currentPassword: {
			required,
		},
	},

	created() {
		// Actions to execute when the component is created
		this.showProfInfo = true; // Set 'showProfInfo' to true by default

		// Fetching device activity, applications, and profile details
		this.getDeviceActivity();
		this.profileDetails();
		this.getCookieData();
		this.getPref();
	},
	watch: {
		currentPassword() {
			this.checkCurrentPsw = false;
		},

		confirmPswd() {
			if (this.newPswd == this.confirmPswd) {
				this.checkConfirmPsw = false;
			}
		},
		newPswd() {
			if (this.newPswd != this.currentPassword) {
				this.checkNewPsw = false;
			}
		},
	},

	methods: {
		async setPref() {
			try {
				this.LoaderStatus = true;
				let payload = {
					defaultModule: this.selected,
					dontAskMeAgain: this.status,
				};
				const res = await postPreference(payload);
				if (res.status == 200) {
					this.successToast("Preference updated successfully");
					this.getPref();
				} else {
					this.errorToast("Could not perform the action");
				}
				this.LoaderStatus = false;
			} catch (error) {
				this.LoaderStatus = false;
				this.errorToast("Could not perform the action");
				console.log(error);
			}
		},
		async getPref() {
			try {
				const res = await getPreference();
				if (res.status == 200) {
					this.selected = res.data.data.defaultModule;
					this.status = res.data.data.dontAskMeAgain;
				}
			} catch (error) {
				console.log(error);
			}
		},
		getCookieData() {
			let data = document.cookie.split(";");
			for (let i in data) {
				let token = data[i].split("=")[0];
				if (token.trim() === "recruitment") {
					this.accessRecruitment = data[i].split("=")[1] !== "no-access";
					this.accessRecruitment ? this.count++ : "";
				}
				if (token.trim() === "training") {
					this.accessTraining = data[i].split("=")[1] !== "no-access";
					this.accessTraining ? this.count++ : "";
				}
				if (token.trim() === "candidate") {
					this.accessCandidate = data[i].split("=")[1] !== "no-access";
					this.accessCandidate ? this.count++ : "";
				}
			}
		},
		cancelResetPswd() {
			this.$v.$reset();
			this.resetPassword = false;
			this.currentPassword = "";
			this.newPswd = "";

			this.confirmPswd = "";
		},
		// Method to reset the password
		async resetPwd() {
			try {
				// Validate form fields
				this.$v.currentPassword.$touch();
				this.$v.newPswd.$touch();
				this.$v.confirmPswd.$touch();

				// Set loading status to true

				// Extract password from Keycloak string

				if (this.newPswd == this.currentPassword) {
					this.checkNewPsw = true;
				} else {
					this.checkNewPsw = false;
				}
				if (this.newPswd != this.confirmPswd) {
					this.checkConfirmPsw = true;
				} else {
					this.checkConfirmPsw = false;
				}

				// Check if form fields are not invalid
				if (
					!this.$v.confirmPswd.$invalid &&
					!this.$v.newPswd.$invalid &&
					!this.$v.currentPassword.$invalid &&
					// this.checkCurrentPsw == false &&
					!this.checkNewPsw &&
					!this.checkConfirmPsw
				) {
					this.LoaderStatus = true; // Set loading status to true

					// Extract password from Keycloak string

					let username = this.User.email;
					let payload = qs.stringify({
						grant_type: "password",
						client_id: "vue-test-app",
						username: username,
						password: this.currentPassword,
					});
					// Send user login request
					const response = await userLogin(payload);

					if (response.status == 200) {
						// If login successful, prepare payload to reset password
						let userpayload = {
							email: username,
							password: this.confirmPswd,
						};
						// Call the API to reset the password
						const res = await resetPassword(userpayload);
						if (res.status == 200) {
							this.$v.$reset();
							this.resetPassword = false; // Set resetPassword flag to false
							this.LoaderStatus = false; // Set loading status to false
							this.successToast("Password reset successful!"); // Show success toast
							this.currentPassword = "";
							this.newPswd = "";

							this.confirmPswd = "";
						} else {
							this.LoaderStatus = false; // Set loading status to false
							this.errorToast("Something went wrong"); // Show error toast
						}
					}
				}
			} catch (error) {
				this.checkCurrentPsw = true;
				this.errorToast("Invalid user credentials");
				this.LoaderStatus = false; // Set loading status to false

				console.error("Error:", error); // Log the error to the console
			}
		},

		// Method to fetch profile details
		async profileDetails() {
			try {
				this.LoaderStatus = true; // Set loading status to true
				let payload = {
					email: this.User.email,
				};
				// Call the API to get profile details
				const res = await getProfileDetails(payload);
				if (res.status == 200) {
					this.LoaderStatus = false; // Set loading status to false
					// Set profileEmail, firstName, and lastName based on API response
					this.profileEmail = res.data.data[0].EMAIL;
					this.firstName = res.data.data[0].FIRST_NAME;
					this.lastName = res.data.data[0].LAST_NAME;
				}
			} catch (error) {
				this.LoaderStatus = false; // Set loading status to false
				this.errorToast("An error occurred"); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},

		// Method to update the profile
		async getProfile() {
			try {
				this.$v.firstName.$touch();
				this.$v.lastName.$touch();
				this.$v.profileEmail.$touch();
				// Check if form fields are not invalid
				if (
					!this.$v.firstName.$invalid &&
					!this.$v.lastName.$invalid &&
					!this.$v.profileEmail.$invalid
				) {
					this.LoaderStatus = true; // Set loading status to true
					// Prepare payload with updated profile information
					let payload = {
						email: this.profileEmail,
						firstName: this.firstName,
						lastName: this.lastName,
					};
					// Call the API to update the profile
					const res = await getProfileInfo(payload);
					if (res.status == 200) {
						this.LoaderStatus = false; // Set loading status to false
						this.successToast("Profile updated successfully"); // Show success toast
					} else {
						this.LoaderStatus = false; // Set loading status to false
						this.errorToast("Something went wrong"); // Show error toast
					}
				} else {
					this.errorToast("Please fill all the fields"); // Show error toast for incomplete fields
				}
			} catch (error) {
				this.LoaderStatus = false; // Set loading status to false
				this.errorToast("An error occurred while updating the profile"); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},

		// Method to format a timestamp
		formatTimestamp(timestamp) {
			// Convert timestamp to a Date object
			const dateObj = new Date(timestamp * 1000);
			// Extract the date components
			const day = String(dateObj.getDate()).padStart(2, "0");
			const month = String(dateObj.getMonth() + 1).padStart(2, "0");
			const year = String(dateObj.getFullYear());
			// Extract the time components
			let hours = dateObj.getHours();
			let minutes = dateObj.getMinutes();
			const ampm = hours >= 12 ? "PM" : "AM";
			hours = hours % 12 || 12;
			hours = String(hours).padStart(2, "0");
			minutes = String(minutes).padStart(2, "0");
			// Concatenate the date and time parts with "at"
			const formattedDateTime = `${day}-${month}-${year} at ${hours}:${minutes} ${ampm}`;
			return formattedDateTime; // Return the formatted date and time
		},

		// Method to fetch applications related to the profile
		// async getApplicationsprofile() {
		//   try {
		//     // Call the API to get applications data
		//     const response = await getApplications();
		//     this.getApplication = response.data; // Update the 'getApplication' array with the API response
		//   } catch (error) {
		//     this.LoaderStatus = false; // Set loading status to false
		//     this.errorToast("An error occurred"); // Show error toast
		//     console.error("Error:", error); // Log the error to the console
		//   }
		// },

		// Method to sign out of all devices
		async signOutAllDevices() {
			await signOutAllDevices(); // Call the API to sign out all devices
		},

		// Method to sign out of a specific device
		async signOut(i) {
			try {
				let payload = {
					id: i.id,
				};
				await signOutDevices(payload); // Call the API to sign out of the specific device
				this.getDeviceActivity(); // Refresh device activity data after sign-out
			} catch (error) {
				this.LoaderStatus = false; // Set loading status to false
				this.errorToast("An error occurred"); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},

		// Method to fetch device activity for the profile
		async getDeviceActivity() {
			try {
				let payload = {
					email: this.profileEmail,
					firstName: this.firstName,
					lastName: this.lastName,
				};

				// Call the API to get device activity data
				const response = await getDeviceActivity(payload);
				const device = response.data; // Extract device activity data from API response

				// Loop through device data and format timestamps
				for (const deviceCheckItem of device) {
					this.deviceCheck = deviceCheckItem.sessions;

					// Use for...of to iterate through sessions
					for (const session of this.deviceCheck) {
						const timestamp = session.lastAccess; // Get the timestamp from the object
						const formattedDateTime = this.formatTimestamp(timestamp); // Call the function to format it
						session.formattedLastAccess = formattedDateTime;
						session.formattedStartedDate = formattedDateTime;
						session.formattedExpire = formattedDateTime;

						console.log(session); // Log the formatted date and time
						// Assign the formatted date and time to a new property
					}
				}
			} catch (error) {
				this.LoaderStatus = false; // Set loading status to false
				this.errorToast("An error occurred"); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},

		// Methods to show/hide different sections of the profile
		showBasicAuth() {
			this.showBasicAut = true;
			this.showProfInfo = false;
			this.showDevAct = false;
			this.showApp = false;
			this.showPreference = false;
		},
		showProfile() {
			this.showProfInfo = true;
			this.showDevAct = false;
			this.showBasicAut = false;
			this.showApp = false;
			this.showPreference = false;
		},
		showDevice() {
			this.showDevAct = true;
			this.showBasicAut = false;
			this.showProfInfo = false;
			this.showApp = false;
			this.showPreference = false;
		},
		showApplication() {
			this.showApp = true;
			this.showDevAct = false;
			this.showBasicAut = false;
			this.showProfInfo = false;
			this.showPreference = false;
		},
		preferenceShow() {
			this.showDevAct = false;
			this.showBasicAut = false;
			this.showProfInfo = false;
			this.showApp = false;
			this.getPref();
			this.showPreference = true;
		},
	},
};
</script>

<style>
.pro-card {
	border-radius: 8px;
	border: 1px solid rgba(20, 20, 20, 0.05);
	background: #fff;
	box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.03);
}

.pro-mainHead {
	color: var(--bg-dynaminChange);
	font-size: 20px;
	font-weight: 500;
}

.candash-head {
	color: var(--grey-500, #3a3c40);
	font-size: 13px;
	font-weight: 500;
}
.pref-setting {
	margin-left: 150px;
}

.pref-cards {
	border-radius: 2px;
	background: #f2f7fb;
	padding: 10px 25px;
	margin-right: 45px;
}

.js-head-txt {
	color: #002;
	font-size: 17px;
	font-weight: 500;
}

.pref-setting .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-color: var(--bg-dynaminChange);
	background-color: var(--bg-dynaminChange);
}

.prof-main-container {
	height: calc(100vh - 70px);
	background: #f9f9f9;
	color: #72738e;
	top: 70px;
	position: relative;
	padding-left: 80px;
}

.heading-container::before {
	content: "";
	display: inline-block;
	position: absolute;
	width: 25px;
	height: 21px;
	top: 2px;
	left: -11px;
	z-index: -1;
	background: var(--cv-yellow);
	-moz-border-radius: 10px;
	-webkit-border-radius: 10px;
	border-radius: 50%;
}

.heading-container {
	position: relative;
	z-index: 1;
	font-weight: 600;
	font-size: 18px;
	color: #72738e;
}
.topDiv > .disable-inputField {
	font-family: "Poppins", sans-serif;
	border: 1px solid #bbbbbb;
	border-radius: 3px !important;
	font-size: 14px;
	color: #6d6d6d;
	box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
	box-sizing: border-box;
}

.profile-main-container {
	height: calc(100vh - 150px);
}

.profile-left-container {
	border-radius: 8px;
	background: #ffffff;
}

.left-selected-container {
	color: #3379b3;
	font-size: 16px;
	font-weight: 800;
	height: 35px;
	background: #f9f9f9;
	position: relative;
}

.blue-line {
	position: absolute;
	left: 0;
	width: 3px;
	height: 100%;
	background: #3379b3;
}

.left-unselected-container {
	background: #fcfcfc;
	font-size: 14px;
	font-weight: 600;
	height: 35px;
}

.profile-right-container {
	padding: 0 5px;
}

.right-selected-container {
	border-radius: 8px;
	background: #ffffff;
	box-shadow: 0px 4px 20px 0px rgba(196, 196, 196, 0.5);
}

.right-selected-heading {
	color: #3379b3;
	font-size: 16px;
	font-weight: 600;
}

.right-heading-container {
	padding: 0px 25px;
	height: 70px;
}

.profile-hr {
	height: 1px;
	background: #c4c4c4;
	margin: 0;
	padding: 0;
}

.profile-form-class {
	padding: 25px;
}

.profile-input {
	font-weight: 400;
	font-size: 12px;
	line-height: 21px;
	background: #fdfdfd;
	border: 0.7px solid rgba(114, 115, 142, 0.7);
	border-radius: 3px !important;
	z-index: 1;
	padding: 10px;
	box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25) inset;
}

.right-unselected-container {
	padding: 0px 25px;
	height: 70px;
	border-radius: 8px;
	background: #ffffff;
	box-shadow: 0px 4px 10px 0px rgba(196, 196, 196, 0.5);
	font-size: 16px;
	font-weight: 600;
}

.profile-password {
	color: #696969;
	font-size: 16px;
	font-weight: 500;
}

.profile-reset-btn {
	background: #f9f9f9;
	border-radius: 3px;
	width: 60%;
	color: #696969;
	font-size: 13px;
	font-weight: 500;
}

.profile-before-colon-text {
	color: #c4c4c4;
	font-size: 13px;
	font-weight: 400;
}

.profile-after-colon-text {
	color: #696969;
	font-size: 13px;
	font-weight: 400;
}

.profile-card-class {
	padding: 10px 20px;
}

.profile-card {
	padding: 15px;
	border-radius: 8px;
	box-shadow: 0px 4px 20px 0px rgba(196, 196, 196, 0.5);
}

.profile-currently-active {
	color: #000;
	font-size: 12px;
	font-weight: 400;
	border-radius: 5px;
	background: #eef2f5;
	width: 120px;
	height: 25px;
	padding: 4px 12px;
	margin-left: 15px;
}

.profile-sign-out {
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: left;
	cursor: pointer;
}
.btn-secondary:focus,
.btn-secondary.focus {
	color: #fff;
	background-color: #5a6268;
	border-color: #545b62;
	box-shadow: unset;
}
.profile-password-text {
	font-family: "Poppins", sans-serif;
	font-size: 12px;
	font-weight: 400;
	color: #e14848;
}
.topDiv > .disable-fieldsetStyle {
	color: var(--bg-tertiary);
	background: #f4f4f4;
	position: absolute;
	left: 0.5vw;
	top: -9px;
	font-size: var(--size-10);
	line-height: 18px;
	z-index: 4;
	padding-left: 6px;
	padding-right: 4px;
}

.cancelbtntxt {
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
}
</style>
